import React, { FC } from 'react';
import { MapPin } from 'react-feather';
import { PVBlack } from '@pv/common/colors';
import type { VoidFn } from '../../../types/common';
import { LocationPicker } from '../pickers/LocationPicker';
import { Selector } from './Selector';
export interface LocationSelectorProps {
  locationQuery: string;
  onChangeLocationQuery: VoidFn<string>;
}

export const LocationSelector: FC<LocationSelectorProps> = ({
  locationQuery,
  onChangeLocationQuery,
}: LocationSelectorProps) => {
  return (
    <Selector>
      <MapPin
        color={PVBlack}
        style={{
          marginBottom: '16px',
        }}
      />
      <LocationPicker
        locationQuery={locationQuery}
        onChangeLocationQuery={onChangeLocationQuery}
        shouldShowOutlineSelector={false}
        shouldRenderIcon={false}
        size={'small'}
      />
    </Selector>
  );
};
